<template>
    <div class="chart-container" v-if="id && titulos && valores">
        <canvas :id="id"></canvas>
    </div>
</template>
<script>
import Chart from 'chart.js'

export default {
    props: {
        id: {
            type: String
        },

        titulos: {
            type: Array
        },

        valores: {
            type: Array
        }
    },

    data() {
        return {
            chartData: {
                labels: this.titulos,
                datasets: [
                    {
                        data: this.valores,
                        backgroundColor: [
                            '#b8b8b8', // Cinza
                            '#D80D00', // Vermelho
                            '#F6C812', // Amarelo
                            '#11B3E1', // Azul
                            '#5BB335' // Verde
                        ]
                    }
                ]
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },

    methods: {
        montarGrafico() {
            var ctx = document.getElementById(this.id)
            var myChart = new Chart(ctx, {
                type: 'pie',
                data: this.chartData,
                options: this.chartOptions
            })
        }
    },

    mounted() {
        this.montarGrafico()
    }
}
</script>

<style>
.chart-container {
    width: 400px;
    height: 400px;
}
</style>
